<section class="confidential" [style.background-color]="themedata.primarytheme">
    <div class="w-100 h-100 align-items-center" fxLayoutAlign="center start" fxLayout="column">
        <div class="heading">
            <h2 class="heading_1 {{ fontData.name }} mt-2" [style.color]="themedata.cardtext">
            </h2>
            <h2 class="heading_2 {{ fontData.name }} mt-2" [style.color]="themedata.cardtext">
            </h2>
            <h2 class="heading_3 {{ fontData.name }} mt-2" [style.color]="themedata.cardtext">
            </h2>
        </div>
        <div class="heading">
            <h2 class="sectionheading {{ fontData.name }} mt-2" [style.color]="themedata.cardtext">
            </h2>
            <h2 class="headingdescription {{ fontData.name }} mt-2" [style.color]="themedata.cardtext">
            </h2>
        </div>
        <div>
            <h2 class="sectionheading {{ fontData.name }}" [style.color]="themedata.cardtext">
                Safeguarding Your Intellectual Property at <strong
                    style="font-family: Robotot; font-weight: bold;">VMANICO
                    TECHNOLOGIES</strong>
            </h2>
        </div>
        <div style="width: 80%;" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="2.257rem">
            <div>
                <img [appLazyLoadImage]="'../../assets/images/CONFIDENTIAL_small.jpeg'" alt=""
                    style="clip-path: circle(60% at 50% 50%);" />
            </div>

            <div class="whatisipdescription {{ fontData.name }}" [style.color]="themedata.cardtext">
                <p style="font-family: Poppins, sans-serif;">
                    At <strong style="font-family: Robotot; font-weight: bold;">VMANICO
                        TECHNOLOGIES</strong>,
                    <b>protecting your intellectual property (IP) is our top
                        priority</b>.
                    We understand that strong intellectual property protection is essential for
                    driving innovation, maintaining a
                    competitive edge,
                    and fostering lasting trust in our services.
                </p>

                <p style="font-family: Poppins, sans-serif;" class="pt-2">
                    <strong style="font-family: Robotot; font-weight: bold;">VMANICO
                        TECHNOLOGIES</strong>
                    implements comprehensive intellectual property protection
                    policies—including robust non-disclosure agreements
                    (NDAs)—to ensure that both your intellectual property
                    and ours remain secure throughout our collaboration.
                    With cutting-edge security measures,
                    strict legal compliance, and clear confidentiality
                    agreements,
                    <strong style="font-family: Robotot; font-weight: bold;">VMANICO
                        TECHNOLOGIES</strong>
                    creates a secure environment for creativity and
                    innovation.
                </p>

            </div>
        </div>
        <div class="d-flex jc-center mt-2">
            <button class="btn" mat-raised-button (click)="agreeConfidentialContent()"
                style="clip-path: circle(50% at 50% 50%);">
                {{ "I Agree" }}
            </button>
            <button class="btn" mat-raised-button (click)="denyConfidentialContent()"
                style="clip-path: circle(50% at 50% 50%);">
                {{ "I Deny" }}
            </button>
        </div>
    </div>
</section>